module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal__content"
  }, [_c('p', {
    staticClass: "mb20"
  }, [_vm._v("Amount that we need to pay: $" + _vm._s(_vm.debtMoney))]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('label', {
    attrs: {
      "for": "pay"
    }
  }, [_vm._v("Amount that we already paid")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentAmount),
      expression: "paymentAmount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "pay",
      "placeholder": "$0"
    },
    domProps: {
      "value": (_vm.paymentAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paymentAmount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('button', {
    staticClass: "btn btn--gray-2 flex__fill-gap mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("Close\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn flex__fill-gap",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("Confirm")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fcc80e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/users/modals/PaymentUserModal.vue
// module id = 434
// module chunks = 2